import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';

class SubstituteData {
  substituteValue: string;
  replaceWith: string;

  constructor(substitute?: string, replace?: string) {
    this.substituteValue = substitute ? substitute : '';
    this.replaceWith = replace ? replace : '';
  }
}

@Component({
  selector: 'app-address-field-substitute',
  templateUrl: './address-field-substitute.component.html',
  imports: [
    ReactiveFormsModule
  ],
  styleUrls: ['../../address-action.component.scss']
})
export class AddressFieldSubstituteComponent implements OnInit, OnDestroy {
  @Input() fieldControl: FormControl;

  substituteForm: FormGroup;
  substituteControl: FormControl;
  substituteControlSubscription: Subscription;
  replacementControl: FormControl;
  replacementControlSubscription: Subscription;

  constructor(private formBuilder: FormBuilder) {
  }

  ngOnInit(): void {
    this.substituteForm = this.formBuilder.group([]);
    this.substituteForm.removeControl('substituteValue');
    this.substituteForm.removeControl('replaceWith');
    if (this.fieldControl.value?.substituteValue || this.fieldControl.value?.replaceWith) {
      this.fieldControl.setValue(new SubstituteData(this.fieldControl.value.substituteValue, this.fieldControl.value.replaceWith));
    } else {
      this.fieldControl.setValue(new SubstituteData());
    }
    this.substituteControl = new FormControl(this.fieldControl.value.substituteValue);
    this.replacementControl = new FormControl(this.fieldControl.value.replaceWith);
    this.substituteForm.addControl('substituteValue', this.substituteControl);
    this.substituteForm.addControl('replaceWith', this.replacementControl);

    if (this.substituteControlSubscription) {
      this.substituteControlSubscription.unsubscribe();
    }
    this.substituteControlSubscription = this.substituteControl.valueChanges.subscribe(value => {
      this.fieldControl.setValue(
        new SubstituteData(value, this.fieldControl.value.replaceWith));
    });
    if (this.replacementControlSubscription) {
      this.replacementControlSubscription.unsubscribe();
    }
    this.replacementControlSubscription = this.replacementControl.valueChanges.subscribe(value => {
      this.fieldControl.setValue(
        new SubstituteData(this.fieldControl.value.substituteValue, value)
      );
    });
  }

  ngOnDestroy(): void {
    if (this.substituteControlSubscription) {
      this.substituteControlSubscription.unsubscribe();
    }
    if (this.replacementControlSubscription) {
      this.replacementControlSubscription.unsubscribe();
    }
  }

}
